export default __webpack_public_path__ + "alberta-sort-next-visit-current.b1fd52f7305a9f324c59.svg";